import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef, Inject, NgModuleRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Attendee } from 'src/app/models/Attendee';
import { Pass } from '../../../models/Pass';
import { LabelsService } from '../../../services/labels.service';
import * as CustomRegistrationFieldModel from '../../../models/CustomRegistrationField';
import { CustomRegistrationFieldsComponent } from './custom-registration-fields/custom-registration-fields.component';
import { Observable, Subscription } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../modal/modal.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { StaticSymbolResolver } from '@angular/compiler';
import Swal from 'sweetalert2'
import { DataService } from "src/app/components/event/data.service";
import { Event } from "src/app/models/Event";
import { ActiveEventService } from "src/app/services/active-event.service";
import { Session } from "src/app/models/Session";
import { DateFormatter } from 'src/app/helpers/DateFormatter';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { EventService } from 'src/app/services/event.service';
import { EVENT_SERVICE } from 'src/app/providers/service.providers';

declare var paypal_sdk: any; 

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[event-attendee]',
    templateUrl: './attendee.component.html',
    styleUrls: ['./attendee.component.scss']
})
export class AttendeeComponent implements OnInit, AfterViewInit {
    @Input() public readableEventId: string;
    @Input() public contactId: string; //Axtrion
    @Input() attendee: Attendee; /* the attendee */
    @Input() passes: Pass[]; /* the event passes */

    /**
     * whether the component is in editing mode or read only mode
     */
    @Input()
    set editing(isEditing: boolean) {
        this._isEditing = isEditing;
        this.editingChange.emit(this._isEditing);
    }

    get editing(): boolean {
        return this._isEditing;
    }

    @Input() deleting: boolean; /* whether the component is in deleting mode or read only mode */
    /* whether the component is a placeholder, meaning it is in editing mode and it does not already represent an entry in the table */
    @Input() placeholder: boolean;
    @Input() waitlisted: boolean; /* whether this is an attendee in the waitlist */
    @Input() isJapanese: boolean; /* whether the language is japanese */
    @Input() autoregisterWaitlistItems: boolean; /* whether automatic registration for waitlisted items is enabled by default */
    @Input() enableAutoRegistrationSelection: boolean; /* whether the checkbox for automatic registration is enabled */
    @Input() customRegistrationFields: CustomRegistrationFieldModel.CustomRegistrationField[];
    @Input() canceledEditing: Function;
    @Input() showAddAnotherAttendee: boolean;
    @Input() hasWaitlistedSessions: boolean;
    @Input() event: Event;
    @Input() termsofConditionChecked: boolean; // TOC CHECKBOX ON EVENTREGISTRATIONCOMPONENT

    @Output() editingChange = new EventEmitter<boolean>(); /* event emitted when the attendee data is updated */
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onSaved = new EventEmitter<Attendee[]>(); /* event emitted when the attendee data is updated */
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onDeleted = new EventEmitter<Attendee>(); /* event fired when the attendee is deleted */
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onAdded = new EventEmitter<Attendee>(); /* event fired when the attendee is added */
    /**
     * This event is triggered whenever the new attendee form is validated.
     */
    @Output() onValidationStatusChanged = new EventEmitter<string>();
    @Output() paymentDetails = new EventEmitter<any>();
    @Output() onPaymentApproved = new EventEmitter<any>(); // AUTOSUBMISSION OF FORM AFTER PAYMENT
    @Output() onAlreadyRegistered = new EventEmitter<any>(); // UPDATE REGISTRATION COMPONENT

    @ViewChild('firstName', { static: false}) firstName: ElementRef;
    @ViewChild('lastName', { static: false}) lastName: ElementRef;
    @ViewChild('attendeeForm', { static: false}) attendeeForm: NgForm;
    @ViewChild('removeAttendeeButton', { static: false}) removeAttendeeButton: ElementRef;
    @ViewChild('customRegistrationFieldsComponent', { static: false}) customRegistrationFieldsComponent: CustomRegistrationFieldsComponent;
    @ViewChild('paypal_sdk', { static: false }) paypalElement: ElementRef;

    private _isEditing: boolean;
    private modalRef: NgbModalRef;
    public PPrice;
    public PDescr;
    public numOfPassesLeft;
    public paidFor = false;
    public sessions: Session[];
    public sessionsCopy: Session[];
    public passisSelected = false;
    public selectedSessions: any = [];
    public firstObservable; // GET THE IDS OF SELECTED SESSIONS
    public SecondObservable; // GET THE NAMES OF SELECTED SESSIONS
    public subscription: Subscription;
    public sessionPrice: number = 0;
    public isPaymentAvailable: boolean = false;
    public displaySessions: Session[];
    public overallSessionIncluded: Boolean = false;
    public eventDate;
    public nowDate;
    public paymentAlreadyDone: Boolean = false; // To Disable The Session Removal After Payment
    public transactionIDPresent; // STORE TRANSACTION_ID CUSTOMREGFIELD OBJECT
    public paidAmountPresent; // STORE TRANSACTION_ID CUSTOMREGFIELD OBJECT
    public freeSessionisSelected; // STORE THE OBJECTS OF FREE SESSIONS
    public foodType; // STORE FOODTYPE CUSTOMREGFIELD
    public foodTypeCheck: any = {}; // ngModels OF FOODTYPE MULTISELECT CHECKBOX
    public foodAllergies; // STORE "Lebensmittelunverträglichkeiten" CUSTOMREGFIELD
    public enableFoodAllergiesCustomRegField = false; // Enable/Disable "Lebensmittelunverträglichkeiten" Field
    public sessionParam; // If Url Params of session is Present Then Save it SessionParam
    public hideIchBin = false; // HIDE ICHBIN CUSTOMREGFIELD IF SELECTED SESSION IS "Mitgliederversammlung (nur für Mitglieder)"
    public IchBinPresent; // SAVE THE CUSTOMREGFIELD "IchBin" TO THIS OBJECT
    public firstNameFromD365; // FETCH FROM D365 TABLE IN CUSTOMREGFIELD COMPONENT
    public lastNameFromD365; // FETCH FROM D365 TABLE IN CUSTOMREGFIELD COMPONENT
    public emailChanged; // RESET ICHBIN FIELD IF EMAIL CHANGED
    public registrationCount;
    public groupselection = undefined;
    public Teilnahmestatus = undefined;
    public passesCopy;
    public unitPurchases: any = [];
    public groupSessionsAvailable;
    public fundingSource = undefined;


    public customRegistrationFieldsCopy: CustomRegistrationFieldModel.CustomRegistrationField[];
    private dummyAttendee: Attendee = {
        firstName: '',
        lastName: '',
        email: '',
        passId: '',
        waitlisted: this.waitlisted,
        autoRegister: false,
        responses: [],
        attendeeSessions: []
    };

    constructor(private labelsService: LabelsService, 
                private modalService: NgbModal,
                private data: DataService,
                @Inject(EVENT_SERVICE) private eventService: EventService,
                private activeEventService: ActiveEventService,
                private datePipe: DatePipe,
                private route: ActivatedRoute,
                private dataService: DataService,
                private datepipe: DatePipe
                ){
                    // this.passesCopy = this.passes;
                }
    
    // IF MORE THAN 1 PASSES ARE AVAILABLE THEN SELECTED PASS PRICE & NAME WILL BE PASSED TO PAYPAL //
    passSelected(val){
        for (let i=0; i<this.passes.length; i++){
            if (this.passes[i].passId == val){
                const price = this.passes[i].price;
                this.PPrice = price;
                this.PDescr = this.passes[i].passName;
                this.numOfPassesLeft = this.passes[i].numberOfPassesLeft;
                this.passisSelected = true;
            }
        }        
    }
    open() {   
        this.modalRef = this.modalService.open(NgbdModalContent);   
        this.sendInputFieldsToModal();
        this.modalRef.result.then(result => {
            if (result === 'Close click' || result === 'Cross click') {
                this.removeAttendeeButton.nativeElement.focus();
            } else if (result === 'Action executed') {
                this.removeAttendee();
                return (this.isJapanese) ? document.getElementById('attendeesLastName').focus() : document.getElementById('attendeesFirstName').focus();            
            }
        });
      }

    sendInputFieldsToModal() {
        const modalsInput = this.modalRef.componentInstance;
        modalsInput.message = 'Are you sure you want to remove {0} {1}?';
        modalsInput.extraParams = this.formatName();
        modalsInput.messageTranslate = 'RemoveMessage';
        modalsInput.primaryButton = 'Remove';
        modalsInput.primaryButtonTranslate = 'Remove';
        modalsInput.secondaryButton = 'Cancel';
        modalsInput.secondaryButtonTranslate = 'Cancel';
        modalsInput.title = 'Remove attendee';
        modalsInput.titleTranslate = 'RemoveAttendee';    
    }

    formatName() {
        let completeName: string[] = [];
        completeName.push(this.attendee.firstName);
        (this.isJapanese) ? completeName.unshift(this.attendee.lastName) : completeName.push(this.attendee.lastName);
        return completeName;
    }

    ngOnDestroy() {        
        // if(this.event && (this.event.readableEventId == 'Jahresversammlung_2026_Mitgliederversammlung' || this.event.readableEventId == 'AXN_Jahresversammlung_2026299457077')){
        if(this.event && (this.event.readableEventId == 'Jahresversammlung_2026_Mitgliederversammlung' || this.event.eventType==100000005)){
            this.SecondObservable.unsubscribe();
        } else {
            this.selectedSessions = []; // CLEAR THE SELECTED SESSION OBJECT IF COMPONENT IS DESTROYED
            this.data.changeMessage(this.selectedSessions)
            this.firstObservable.unsubscribe();
        }
    }
    // ENABLE/DISABLE "Lebensmittelunverträglichkeiten" CUSTOMREGFIELD
    ChangeValueofFoodType(val){
        if(this.foodTypeCheck['Lebensmittelunverträglichkeiten']==true){
            this.enableFoodAllergiesCustomRegField = true;
        }
        else if (this.foodTypeCheck['Lebensmittelunverträglichkeiten']==false){
            this.enableFoodAllergiesCustomRegField = false;
        }
        
    }

    async ngOnInit() {
        localStorage.removeItem('ContactId');
        this.route.queryParamMap.subscribe(paramMap => {
            this.sessionParam = paramMap.get("session"); //Mitgliederversammlung //Nachfolgekonferenz
        });

        this.eventService.getEventRegistrationCount(this.readableEventId)
        .subscribe(eventCount => {
            this.registrationCount = eventCount;
        });

        window.scroll({ 
            top: 0, 
            left: 0, 
            behavior: 'smooth' 
        });
        
        if(this.event && this.event.msevtmgt_registrationenddate){
            this.eventDate = new Date(this.event.msevtmgt_registrationenddate).getTime();
        }
        this.nowDate = new Date().getTime();
        // IF EVENT HAS END DATE
        if(this.event.endDate!=null && new Date(this.event.endDate).getTime() < this.nowDate){
            window.location.href = `event/sessions?id=${this.readableEventId}`;
        }
        // IF EVENT HAS REGISTRATION CLOSE DATE
        if (this.event && this.event.msevtmgt_setregistrationperiod) {
            if(this.event.msevtmgt_registrationenddate!=null){
                // IF REGISTRATION CLOSED DATE HAS PASSED
                if(new Date(this.event.msevtmgt_registrationenddate).getTime() < this.nowDate){
                    window.location.href = `event/sessions?id=${this.readableEventId}`;
                }
            }
            if (this.event.msevtmgt_registrationstartdate!=null) {
                // IF REGISTRATION START DATE HAS NOT BEEN REACHED
                if(new Date(this.event.msevtmgt_registrationstartdate).getTime() > this.nowDate){
                    window.location.href = `event/sessions?id=${this.readableEventId}`;
                }
            } 
        }
        
        // IF ONLY 1 PASS IS AVAILABLE THEN IT WILL BE SHOWN READONLY ON REGISTRATION //
        if(this.passes && this.passes.length==1){
            this.PPrice = this.passes[0].price;
            this.PDescr = this.passes[0].passName;
            this.numOfPassesLeft = this.passes[0].numberOfPassesLeft;
            this.passisSelected = true;
        }

        // console.log("Event Component:- ", this.event);
        
        this.sessions = await this.activeEventService.getSessions(this.readableEventId).toPromise();
        this.sessionsCopy = this.sessions;

        this.firstObservable = this.data.currentMessage.subscribe(message => {
            this.selectedSessions = message

            this.displaySessions = this.sessions;

            this.sessions = this.sessions.filter(o => this.selectedSessions.includes(o.id) );

            this.overallSessionIncluded = ((this.sessionsCopy.filter(el => this.selectedSessions.includes(el.id))).filter(el => el.sessionType==150170001)).length>0;
                        

            if (this.overallSessionIncluded){
                this.displaySessions = this.sessionsCopy.filter(el => {
                    return el.sessionType == 150170002 || el.sessionType == 150170003;
                });
                this.groupSessionsAvailable = this.displaySessions;                
            }

            if(this.sessions && this.sessions.length>0){
                // IF OVERALL SESSION IS INCLUDED THEN REMOVE THE OTHER ASSOCIATED SESSIONS FROM OBJECT 
                if(this.overallSessionIncluded){
                    this.sessions = this.sessions.filter( el => {
                        return el.sessionType != 150170002 && el.sessionType != 150170003;
                    })
                }
                // AMOUNT CALCULATION FOR SESSIONS
                this.calculateSessionsAmount();
            }

            // console.log("From Observers:- ", this.selectedSessions);
        });

        // IF EVENT ID IS "Jahresversammlung_2026_Mitgliederversammlung" THEN GET THE SESSIONS W.R.T NAMES
        if(this.event && ( this.event.readableEventId == 'Jahresversammlung_2026_Mitgliederversammlung' )){
            if(this.sessionParam){ // IF URL PARAM IS PRESENT "session"
                this.SecondObservable = this.data.currentName.subscribe( message => {
                    this.freeSessionisSelected = this.sessionsCopy.filter(el => message.includes(this.sessionParam))
                });
                this.freeSessionisSelected = this.sessionsCopy.filter(el => el.name == this.sessionParam)
                // console.log("FreeSelectedSessionsByParams:-", this.freeSessionisSelected);
                this.sessions = this.freeSessionisSelected;
            } else { // IF REDIRECTED FROM OTHER MAIN CONFERENCE EVENT
                this.SecondObservable = this.data.currentName.subscribe( message => {
                    this.freeSessionisSelected = this.sessionsCopy.filter(el => message.includes(el.name))
                    // console.log("FreeSelectedSessions:-", this.freeSessionisSelected);
                    this.sessions = this.freeSessionisSelected;
                });
            }
            // NO LONGER REQUIRED //
            // if(this.freeSessionisSelected && this.freeSessionisSelected.length==1 && this.freeSessionisSelected[0].name=='Mitgliederversammlung (nur für Mitglieder)'){
            //     this.hideIchBin = true;
            // }
        }

        if (!this.attendee) {
            this.setDummyAttendee();
        }
        
        this.customRegistrationFieldsCopy = this.createDeepCopyOfCustomRegistrationFields();

        // NO LONGER REQUIRED //
        // IF "Mitgliederversammlung (nur für Mitglieder)" IS SELECTED ONLY
        // if(this.hideIchBin){ // HIDE ICHBIN FIELD FROM THE MAIN OBJECT
        //     this.IchBinPresent = this.customRegistrationFieldsCopy.filter(el => el.text == 'Ich bin (Teilnahmestatus)');
        //     if(this.IchBinPresent && this.IchBinPresent.length==1){
        //         this.customRegistrationFieldsCopy = this.customRegistrationFieldsCopy.filter(el => el.text != 'Ich bin (Teilnahmestatus)');
        //     }
        // }

        // IF FOOD_TYPE FIELD PRESENT THEN STORE THE INFO IN OBJECT
        this.foodType = this.customRegistrationFields.filter(el => {
            return el.text == "Teilen Sie uns bitte mit, ob Sie Lebensmittelunverträglichkeiten haben, Vegetarier oder Veganer sind."
        });
        // IF FOOD_TYPE FIELD PRESENT THEN REMOVE IT FROM MAIN CUSTOMREGFIELD OBJECT
        if(this.foodType && this.foodType.length==1){
            for(let i=0; i<this.foodType[0].choicesArray.length; i++){
                this.foodTypeCheck[this.foodType[0].choicesArray[i]] = false;
            }
            this.customRegistrationFieldsCopy = this.customRegistrationFieldsCopy.filter( el => {
                return el.text != 'Teilen Sie uns bitte mit, ob Sie Lebensmittelunverträglichkeiten haben, Vegetarier oder Veganer sind.';
            });
            this.foodAllergies = this.customRegistrationFieldsCopy.filter(el => el.text == 'Lebensmittelunverträglichkeiten');
            if(this.foodAllergies && this.foodAllergies.length==1) {
                this.customRegistrationFieldsCopy = this.customRegistrationFieldsCopy.filter(el => el.text != 'Lebensmittelunverträglichkeiten');
            }
        }
        // IF TRANSACTION_ID FIELD PRESENT THEN STORE THE INFO IN OBJECT
        this.transactionIDPresent = this.customRegistrationFields.filter( el => {
            return el.text == 'Transaktions_ID';
        });
        // IF TRANSACTION_ID FIELD PRESENT THEN REMOVE IT FROM MAIN CUSTOMREGFIELD OBJECT
        if(this.transactionIDPresent && this.transactionIDPresent.length>0){
            this.customRegistrationFieldsCopy = this.customRegistrationFieldsCopy.filter( el => {
                return el.text != 'Transaktions_ID';
            });
        }

        this.paidAmountPresent = this.customRegistrationFields.filter( el => {
            return el.text == 'Paid_Amount';
        });
        // IF PAID_AMOUNT FIELD PRESENT THEN REMOVE IT FROM MAIN CUSTOMREGFIELD OBJECT
        if(this.paidAmountPresent && this.paidAmountPresent.length>0){
            this.customRegistrationFieldsCopy = this.customRegistrationFieldsCopy.filter( el => {
                return el.text != 'Paid_Amount';
            });
        }
        
    }
    async ngOnChanges(){
        if(this.event && this.event.eventType == 150170001 && this.passes && this.passes.length==2){
            this.dataService.currentGroup.subscribe(res => {
                this.groupselection = res ? res : undefined;                
                if(this.groupselection!=undefined){
                    if(this.groupselection.length>0 && this.groupselection == 'Mitglied'){
                        this.groupselection = this.passes.filter(el => {
                            return el.cr9fc_tickettype == 150170000;
                        })[0]['passId'];
                        this.passSelected(this.groupselection);
                        
                    } else {
                        this.groupselection = this.passes.filter(el => {
                            return el.cr9fc_tickettype == 150170001;
                        })[0]['passId'];
                        this.passSelected(this.groupselection);
                    }                
                } else {
                    this.groupselection == undefined;
                    this.passSelected(undefined);
                }
            });
        } else if (this.event && this.event.eventType == 150170001 && this.passes && this.passes.length>2){
            this.dataService.currentGroup.subscribe(res => {
                this.Teilnahmestatus = res ? res : undefined;
                if(this.Teilnahmestatus == 'Mitglied'){
                    this.passesCopy = this.passes.filter(el => {
                        return el.cr9fc_tickettype !== 150170001; 
                    });
                } else {
                    this.passesCopy = this.passes.filter(el => {
                        return el.cr9fc_tickettype !== 150170000; 
                    });
                }
            });
        }
        // WON'T CHECK FOR CONFERENCETYPE EVENTS //
        if(this.termsofConditionChecked){
            if(this.event && this.event.eventType!==100000005){
                const fname = this.attendeeForm.controls.firstName.value;
                const lname = this.attendeeForm.controls.lastName.value;
                const email = this.attendeeForm.controls.email.value;
                if(this.attendeeForm.invalid && (fname.length==0 || lname.length==0 || email.length==0)){
                    await Swal.fire({
                        icon: 'error',
                        title: 'Unvollständiges Anmelde-Formular!',
                        text: `Bitte füllen Sie alle Pflichtfelder aus.`,
                    });
                    this.onAlreadyRegistered.emit(true);
                } else {
                    const payload = { readableEventId: this.readableEventId, email: email }
                    Swal.fire({
                        title: 'Bitte warten Sie...',
                        timerProgressBar: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading(null);
                            this.dataService.getUserRegistrationDetails(payload).subscribe(async res => {
                                let result = await JSON.parse(JSON.stringify(res));
                                if(result.value.length>0){
                                    const Regdate = this.datepipe.transform(result.value[0].createdon, 'dd.MM.yyyy');
                                    await Swal.fire({
                                        icon: 'error',
                                        title: 'Sie sind bereits mit der Emailadresse '+email+' für diese Veranstaltung registriert.',
                                        html: `Datum der Registrierung<br><b>${Regdate}</b>`,
                                    });
                                    this.onAlreadyRegistered.emit(true);
                                } else {
                                    Swal.close();
                                }
                            });
                        }
                    });
                }   
            }
        }
    }

    ngAfterViewInit() {
        this.subscribeToAttendeeFormChanges();
        this.payment();
    }
    public calculateSessionsAmount(){
        this.sessionPrice = 0;
        this.unitPurchases = [];        
        if(this.sessions && this.sessions.length>0){
            for(let i=0; i<this.sessions.length; i++){
                for(let j=0; j<this.selectedSessions.length; j++){
                    if((this.sessions[i].id == this.selectedSessions[j]) && this.sessions[i].cr9fc_new_sessionprice ){
                        this.sessionPrice += this.sessions[i].cr9fc_new_sessionprice.value;
                        this.unitPurchases.push({ name: this.sessions[i].name, unit_amount : { currency_code: "EUR", value: this.sessions[i].cr9fc_new_sessionprice.value}, quantity: "1"});
                    }
                }
            }
            if(this.overallSessionIncluded){
                this.groupSessionsAvailable.forEach(el => {
                    this.unitPurchases.push({ name: el.name, unit_amount : { currency_code: "EUR", value: "0"}, quantity: "1"});
                });
            }
        }
    }
    // ================================ PAYMENT METHOD FOR PAYPAL ================================//
    public payment(){
        if(this.paypalElement !== undefined){
            if(this.passes && this.passes.length>0){ // IF PASSES AVAILABLE
                paypal_sdk
                .Buttons({
                    onClick: async (data, actions)=> {
                        if(!this.passisSelected){ // IF NO PASS IS SELECTED THEN DIALOGUE APPEAR
                            Swal.fire(
                                'No Pass is Selected',
                                'Please Select the Pass First',
                                'warning'
                                );
                            return actions.reject()
                        } else if (this.numOfPassesLeft==0){ // IF SELECTED PASS IS ALREADY SOLD
                            Swal.fire(
                                'Sorry Selected Pass are Already Sold out',
                                'Please Select Any Other Pass',
                                'warning'
                                );
                            return actions.reject()
                        } else if (this.eventDate && this.eventDate < this.nowDate){ // IF EVENT DATE PASSED                     
                            Swal.fire(
                                'Sorry! Registrations are closed for this Event',
                                '',
                                'warning'
                                );
                            return actions.reject()
                        } else if (!this.attendeeForm.valid || !this.termsofConditionChecked || !this.customRegistrationFieldsComponent.areRegistrationFieldsValid()){ // IF FORM IS INCOMPLETE
                            Swal.fire(
                                'Bitte füllen Sie das Formular inklusive der Einwilligung zur Datenverarbeitung aus!',
                                '',
                                'warning'
                                );
                            return actions.reject()
                        } else if (this.event && this.event.maxCapacity!=0 && this.registrationCount>=this.event.maxCapacity){
                            Swal.fire(
                                'Dieses Ereignis ist ausverkauft.',
                                '',
                                'warning'
                                );
                            return actions.reject()
                        } else {
                            this.fundingSource = data.fundingSource;
                        }
                    },
                    style: {
                        color: 'silver'
                    },
                    createOrder: (data, actions) => { // ORDER CREATION WITH SELECTED PASS
                        return actions.order.create({
                            purchase_units: [
                                {
                                    description: this.datePipe.transform(this.event.startDate, 'dd.MM.yy')+' ('+this.event.cr9fc_regionen.substring(0,60)+') '+this.event.eventName.substring(0,50),
                                    amount: {
                                        value: this.PPrice
                                    },
                                    custom_id: this.fundingSource
                                }
                            ]
                        });
                    },
                    onApprove: async (data, actions) => { // ORDER APPROVAL WITH SELECTED PASS
                        const order = await actions.order.capture();
                        this.transactionIDPresent[0].value = order.purchase_units[0].payments.captures[0].id; 
                        this.paidAmountPresent[0].value = this.PPrice;                       
                        this.paidFor = true;
                        // PAYMENT IS SUCCESSFUL
                        Swal.fire({
                            title: 'Zahlung erfolgreich!',
                            text: 'Vielen Dank für Ihre Anmeldung',
                            icon: 'success',
                            timer: 7000,
                            timerProgressBar: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false
                        })
                        this.paymentDetails.emit(order); // PAYMENT DETAILS WILL PASS TO REGISTRATION COMPONENT
                        this.paidFor = true; // PAYPAL BUTTON WILL BE HIDDEN AFTER PAYMENT
                        this.onPaymentApproved.emit(this.paidFor); // AUTO SUBMIT IF PAYMENT IS DONE
                    },
                    onError: err => {
                        console.log("Error Occurred:- ", err);                   
                    }

                }).render(this.paypalElement.nativeElement);
            }
            else if (this.event && this.event.eventType==100000005){ // IF SESSIONS AVAILABLE
                paypal_sdk
                .Buttons({
                    onClick: async (data, actions)=> {
                        if(this.selectedSessions == 0){ 
                            // IF NO SESSIONS ARE SELECTED THEN DIALOGUE APPEAR
                            Swal.fire(
                                'Sie haben keine Programmpunkte ausgewählt.',
                                'Bitte stellen Sie erst Ihre Agenda zusammen.',
                                'warning'
                                );
                            return actions.reject()
                        }
                        else if (this.eventDate && this.eventDate < this.nowDate){
                            // SORRY REGISTRATIONS ARE CLOSED                          
                            Swal.fire(
                                'Der Anmeldezeitraum für die Veranstaltung ist leider abgelaufen.',
                                'Für Rückfragen steht Ihnen Ina Lindner gern zur Verfügung: Tel. 030/200 59 19 11 oder ina.lindner@vdu.de',
                                'warning'
                                );
                            return actions.reject()
                        } else if (!this.attendeeForm.valid || !this.termsofConditionChecked || !this.customRegistrationFieldsComponent.areRegistrationFieldsValid()){ // IF FORM IS INCOMPLETE
                            Swal.fire(
                                'Bitte füllen Sie das Formular inklusive der Einwilligung zur Datenverarbeitung aus!',
                                '',
                                'warning'
                                );
                            return actions.reject()
                        } else {
                            this.fundingSource = data.fundingSource;
                        }
                    },
                    style: {
                        color: 'silver'
                    },
                    createOrder: (data, actions) => { // ORDER CREATION WITH SELECTED SESSIONS
                        return actions.order.create({
                            purchase_units: [
                                {
                                    amount: {
                                        currency_code: "EUR",
                                        value: this.sessionPrice,
                                        breakdown: {
                                            item_total: {
                                                currency_code: "EUR",
                                                value: this.sessionPrice
                                            }
                                        }
                                    },
                                    items: this.unitPurchases,
                                    custom_id: this.fundingSource
                                }
                            ]
                        });
                    },
                    onApprove: async (data, actions) => { // ORDER APPROVAL WITH SELECTED SESSIONS
                        const order = await actions.order.capture();
                        this.transactionIDPresent[0].value = order.purchase_units[0].payments.captures[0].id;
                        this.paidAmountPresent[0].value = this.sessionPrice;
                        this.paidFor = true;
                        Swal.fire({
                            title: 'Zahlung erfolgreich!',
                            text: 'Vielen Dank für Ihre Anmeldung',
                            icon: 'success',
                            timer: 7000,
                            timerProgressBar: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false
                        })
                        this.paymentDetails.emit(order); // PAYMENT DETAILS WILL PASS TO REGISTRATION COMPONENT
                        this.paidFor = true; // PAYPAL BUTTON WILL BE HIDDEN AFTER PAYMENT
                        this.onPaymentApproved.emit(this.paidFor);
                        this.paymentAlreadyDone = true; // IF PAYMENT IS DONE THEN DISABLE SESSION REMOVAL FROM REG PAGE
                    },
                    onError: err => {
                        console.log("Error Occurred:- ", err);                   
                    }

                }).render(this.paypalElement.nativeElement);
            }
        }
    }
    // ===========================================================================================//

    public confirmEdit(): void {
        const attendeeBefore = this.deepCloneAttendee(this.attendee);
        const IchBinPresentinCustomRegField = this.customRegistrationFields.filter(el => el.text == 'Ich bin (Teilnahmestatus)');

        this.attendee = {
            firstName: this.capitalFirstLetter(this.attendeeForm.value.firstName),
            lastName: this.capitalFirstLetter(this.attendeeForm.value.lastName),
            email: this.attendeeForm.value.email.toLowerCase(),
            passId: this.attendeeForm.value.passId ? this.attendeeForm.value.passId : this.groupselection,
            waitlisted: this.waitlisted,
            autoRegister: this.attendeeForm.value.isAutoRegisterEnabled || false,
            responses: this.customRegistrationFieldsComponent.getCustomRegistrationFieldsResponses(),
            attendeeSessions: []
        };
        
        
        let group = this.attendee.responses.filter(el => {
            return el.id == 'Ich_bin_Teilnahmestatus'
        });
        if(!this.contactId && IchBinPresentinCustomRegField && IchBinPresentinCustomRegField.length==1){
            if(group[0].value !== 'Gast'){
                this.attendee.firstName = this.firstNameFromD365;
                this.attendee.lastName = this.lastNameFromD365;
            }
        }        
        if(this.hideIchBin){
            this.attendee.responses.push({  id: this.IchBinPresent[0].customRegistrationFieldId,
                                            value: 'Mitglied', 
                                            values: null})
        }
        // IF EVENT ID IS "Jahresversammlung_XXXX_Mitgliederversammlung" THEN UPDATE THE FINAL OBJECT WITH SELECTED SESSIONS
        if(this.event && (this.event.readableEventId == 'Jahresversammlung_2026_Mitgliederversammlung')){
            this.freeSessionisSelected.forEach(el => {
                this.attendee.attendeeSessions.push({sessionId: el.id, waitlisted: false});
            });
        }
        if(this.passes && this.passes.length==1){
            this.attendee.passId = this.passes[0].passId;
        }
        if(this.selectedSessions && this.selectedSessions.length>0 && this.event.readableEventId != 'Jahresversammlung_2026_Mitgliederversammlung'){
            
            for(let i=0; i<this.selectedSessions.length; i++){
                this.attendee.attendeeSessions.push({sessionId: this.selectedSessions[i], waitlisted: false});
            }
            if(group[0].value != 'Mitglied'){
                let mitgliederversammlungSession = this.sessionsCopy.filter(el => {
                    return el.name == 'Mitgliederversammlung (nur für Mitglieder)';
                });
                this.attendee.attendeeSessions = this.attendee.attendeeSessions.filter(el => {
                    return el.sessionId != mitgliederversammlungSession[0].id;
                });
            }
        }
        // UPDATE THE ATTENDEE RESPONSE OBJECT WITH TRANSACTION_ID CUSTOMREGFIELD
        if (this.transactionIDPresent && this.transactionIDPresent.length>0){
            this.attendee.responses
                    .push({id: this.transactionIDPresent[0].msevtmgt_fieldlogicalname,
                            value: this.transactionIDPresent[0].value, 
                            values: null});
        }
        // UPDATE THE ATTENDEE RESPONSE OBJECT WITH AMOUNT_PAID CUSTOMREGFIELD
        if (this.paidAmountPresent && this.paidAmountPresent.length>0){
            this.attendee.responses
                    .push({id: this.paidAmountPresent[0].msevtmgt_fieldlogicalname,
                            value: this.paidAmountPresent[0].value, 
                            values: null});
        }
        // UPDATE THE ATTENDEE OBJECT WITH FOODTYPE CUSTOMREGFIELD VALUES
        if(this.foodType && this.foodType.length==1){
            let selectedtype = [];
            for (const [key, value] of Object.entries(this.foodTypeCheck)) {
                if(value == true){
                    selectedtype.push(key)
                }
            }
            this.attendee.responses
                    .push({id: this.foodType[0].customRegistrationFieldId,
                           value: selectedtype.toString(),
                           values: selectedtype
            });
            // UPDATE THE ATTENDEE OBJECT WITH "Lebensmittelunverträglichkeiten" CUSTOMREGFIELD VALUES
            if(this.foodAllergies && this.foodAllergies.length==1 && this.enableFoodAllergiesCustomRegField){
                this.attendee.responses
                        .push({id: this.foodAllergies[0].customRegistrationFieldId,
                               value: this.foodAllergies[0].value,
                               values: null
                });
            }
        }

        
        if (!this.placeholder && this.editing) {
            // existing attendee was updated
            this.editing = false;
            if (attendeeBefore.passId !== this.attendee.passId) {
                this.incrementPassesUsed(this.attendee.passId);
                this.decrementPassesUsed(attendeeBefore.passId);
            }
            this.onSaved.emit([attendeeBefore, this.attendee]);


        } else if (!this.placeholder && this.deleting) {
            // existing attendee was deleted
            this.deleting = false;
        } else {
            // attendee added
            if (this.attendee.passId) {
                this.incrementPassesUsed(this.attendee.passId);
            }

            this.onAdded.emit(this.attendee);
            // console.log("POST Attendee:-", this.attendee);
            
            this.resetNewAttendeeForms();
            localStorage.clear();
        }
    }

    /**
     * Checks if all forms (attendee form + custom registrations form) are valid.
     */
    public areFormsValid() {
        const attendeeFormValid = this.attendeeForm && this.attendeeForm.valid;
        const customRegistrationFieldsFormValid = this.customRegistrationFieldsComponent &&
            this.customRegistrationFieldsComponent.areRegistrationFieldsValid();

        if (this.customRegistrationFields == null || this.customRegistrationFields.length === 0) {
            return attendeeFormValid;
        } else {
            return attendeeFormValid && customRegistrationFieldsFormValid;
        }
    }

    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }

    public getCntOfWaitlistedSessionsForAttendee(): number {
        if (this.attendee == null || this.attendee.attendeeSessions == null || this.attendee.attendeeSessions.length === 0) {
            return 0;
        }

        return this.attendee.attendeeSessions.filter(as => as.waitlisted === true).length;
    }

    private resetNewAttendeeForms() {
        this.setDummyAttendee();

        this.attendeeForm.reset();
        this.customRegistrationFieldsComponent.resetForm();

        // angular sets the values to null on reset. we  we need to manually select the placeholder value for the pass dropdown
        if (this.attendeeForm.controls.passId) {
            this.attendeeForm.controls.passId.setValue('');
        }
    }

    private subscribeToAttendeeFormChanges() {
        if (this.attendeeForm) {
            this.attendeeForm.statusChanges.subscribe(result => {
                this.onValidationStatusChanged.emit(result);
            });
        }
    }

    private cancelEdit(): void {
        this.editing = false;
        this.canceledEditing();
    }

    public switchToEdit(attendee: Attendee): void {
        this.editing = true;
    }

    private removeAttendee(): void {
        this.deleting = true;
        if (this.attendee.passId) {
            this.decrementPassesUsed(this.attendee.passId);
        }
        this.onDeleted.emit(this.attendee);
    }

    private setDummyAttendee() {
        this.attendee = this.deepCloneAttendee(this.dummyAttendee);
        this.fillAttendeeById_base64();
    }

    private passDisplayString(passId: string): string {
        const pass = this.pass(passId);
        return `${pass.passName} (${pass.currencySymbol}${pass.price})`;
    }

    private pass(passId: string): Pass {
        const idx = this.passes.findIndex(p => p.passId === passId);
        return this.passes[idx];
    }

    private incrementPassesUsed(passId: string): void {
        this.pass(passId).passesUsed++;
    }

    private decrementPassesUsed(passId: string): void {
        this.pass(passId).passesUsed--;
    }

    private deepCloneAttendee(obj: Attendee): Attendee {
        return JSON.parse(JSON.stringify(obj)) as Attendee;
    }

    private createDeepCopyOfCustomRegistrationFields(): CustomRegistrationFieldModel.CustomRegistrationField[] {
        const customFieldsCopy: CustomRegistrationFieldModel.CustomRegistrationField[] = [];

        if (this.customRegistrationFields == null) {
            return [];
        }

        for (const customRegistrationField of this.customRegistrationFields) {
            customFieldsCopy.push(
                customRegistrationField.createDeepCopy()
            );
        }

        return customFieldsCopy;
    }

    private changeFocus() {
        if (this.isJapanese) {
            this.lastName.nativeElement.focus();
        } else {
            this.firstName.nativeElement.focus();
        }
    }
    public getDateString(session: Session): string {
        let dateSettings = DateFormatter.getDateSettings();
        // if(dateSettings.convertToLocalDate){
        //     return DateFormatter.formatRangedDate(this.datePipe, session.startTimeUTC, session.endTimeUTC);
        // }
        // else {
        //     return DateFormatter.formatRangedDate(this.datePipe, session.startTime, session.endTime, session.timeZone);
        // }
        let d1Day = new Date(session.startTime).getDate(); // TO COMPARE STARTDATE
        let d2Day = new Date(session.endTime).getDate(); // TO COMPARE ENDDATE
        let d1 = this.datePipe.transform(session.startTime, 'dd. MMM yyyy, HH:mm '); // FORMATTED START DATE
        let d2 = this.datePipe.transform(session.endTime, 'dd. MMM yyyy, HH:mm '); // FORMATTED END DATE
        if(d1Day === d2Day){ // IF START & END DATE IS SAME THEN REMOVE DATE FROM ENDDATE AND SHOW TIME ONLY
            return (d1+'Uhr - '+d2.substring(13,20)+'Uhr');
        }
        else { // IF START & END DATE IS DIFFERENT THEN SHOW THE WHOLE DATE
            return (d1+'Uhr - '+d2+'Uhr');
        }
    }
    updateSessions(val){
        if(!this.paymentAlreadyDone){
            Swal.fire({
                title: 'Sind Sie sicher?',
                text: "Hiermit löschen Sie Ihren gewählten Programmpunkt!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ja',
                cancelButtonText: 'Abbrechen'
                }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire(
                    'Entfernt!',
                    'Ihre Auswahl wurde entfernt.',
                    'success'
                    )
                    // ======== RETURN OVERALL SESSION OBJECT ========
                    let isSessionOverall = this.sessionsCopy.filter( el => {
                        return el.sessionType == 150170001;
                    })
                    // ======== REMOVE OVERALL SESSION & GROUP SESSIONS AS WELL ========
                    if(isSessionOverall[0].id == val){
                        this.selectedSessions = this.selectedSessions.filter(function(value, index, arr){ 
                            return value !== val;
                        });       
                        let isGroupSessions = this.sessionsCopy.filter( el => {
                            return el.sessionType == 150170002 || el.sessionType == 150170003 || el.sessionType == 100000005;
                        });
                        this.selectedSessions.forEach(el => {
                            for (let i=0; i<isGroupSessions.length; i++){
                                if (el == isGroupSessions[i].id){
                                    this.selectedSessions = this.selectedSessions.filter(function(value, index, arr){ 
                                        return value !== el;
                                    }); 
                                }
                            }
                        });
                        this.overallSessionIncluded = false;
                    } // ========= IF SELECTED SESSION IS NOT OVERALL THEN JUST REMOVE THE SESSION =======
                    else {
                        this.selectedSessions = this.selectedSessions.filter(function(value, index, arr){ 
                            return value !== val;
                        }); 
                    }
                    // UPDATE SELECTED SESSION OBJECT
                    this.data.changeMessage(this.selectedSessions);
                }
            });
        }
        else {
            Swal.fire({
                title: 'Sie haben bereits gezahlt.',
                text: "Sie können hier keine Programmpunkte mehr löschen. Bei Fragen wenden Sie sich bitte an die Geschäftsstelle (030/200 59 19 10 oder info@vdu.de).",
                icon: 'info',
            });
        }
    }
    private fillAttendeeById_base64() { // Axtrion
        if (!this.contactId) return;
        var decoded = decodeURIComponent(atob(this.contactId).split('').map(x => '%' + x.charCodeAt(0).toString(16)).join(''));
        var vals = decoded.split('_AXTSEP_').filter(e => e); // special seperator cause email could contain "_"
        if (vals.length>0) this.attendee.firstName = vals[0];
        if (vals.length>1) this.attendee.lastName  = vals[1];
        if (vals.length>2) this.attendee.email     = vals[2];
        // WHEN CN IS USED THEN PASS EMAIL TO SERVICE
        if(this.attendee && this.attendee.email) this.data.changeEmail(this.attendee.email); 
   }
    private capitalFirstLetter(str){
        str = str.toLowerCase();
        const strTemp = []; // Use an array for easier manipulation
    
        for (let i = 0; i < str.length; i++) {
            if (i === 0 || str[i - 1] === ' ' || str[i - 1] === '-') {
                strTemp.push(str[i].toUpperCase());
            } else {
                strTemp.push(str[i]);
            }
        }
        return strTemp.join('');
    }
    public getEmail(val: string){
        this.data.changeEmail(val);
        this.emailChanged = val;
        this.termsofConditionChecked=false;
        this.onAlreadyRegistered.emit(true);
    }
    public getFirstNamefromD365(val){
        this.firstNameFromD365 = val;        
    }
    public getLastNamefromD365(val){
        this.lastNameFromD365 = val;
    }
}

